import { updateProfile } from '../api/system'

function saveUserProfile(phone, newPassword) {
  return updateProfile({
    phone,
    newPassword
  })
}

export { saveUserProfile }
